import ProductCard from './ProductCard';

/**
 * Rejilla de tarjetas de producto.
 *
 * La usan tanto la tienda como los destacados de la portada, y por eso las
 * medidas viven aquí y no en cada página: al tener cada una su propia rejilla,
 * las tarjetas salían de anchos distintos entre la portada y la tienda, y con
 * ellas el recuadro de la foto, que es cuadrado y por tanto sigue al ancho.
 */
export default function ProductGrid({ products = [], source, className = '' }) {
  return (
    <div
      className={`max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 ${className}`}
    >
      {products.map(product => (
        <ProductCard key={product.id} product={product} source={source} />
      ))}
    </div>
  );
}
